import * as React from 'react';
import { Field } from 'redux-form';
import { TextInput, required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CreateItem from '../Partials/CreateItem';
import DeleteItem from '../Partials/DeleteItem';

const ValidateRequired = required();

const styles = createStyles({
  name: {
    width: '90%'
  },
  value: {
    width: '80%'
  }
});

type Props = {
  addItemLabel: string,
  baseName: string,
  classes: any,
  containerWidth?: string,
  fields: any,
  keyLabel: string,
  keyName: string,
  mainLabel: string,
  valueLabel?: string,
  valueName?: string
};

const KeyValueInput: React.SFC<Props> = (props: Props) => (
  <div>
    <div style={{ fontWeight: 'bold' }}>{props.mainLabel}</div>
    {props.fields.length > 0 && props.fields.map((item, index) => {
      return (
        <div key={index} style={{ display: 'flex', width: props.containerWidth }}>
          <div style={{ flex: '1' }}>
            <Field
              className={props.classes.name}
              component={TextInput}
              label={props.keyLabel}
              name={`${props.baseName}[${index}].${props.keyName}`}
              source={`${props.baseName}[${index}].${props.keyName}`}
              validate={ValidateRequired} /><br />
          </div>
          <div style={{ flex: '2' }}>
            <Field
              className={props.classes.value}
              component={TextInput}
              label={props.valueLabel}
              name={`${props.baseName}[${index}].${props.valueName}`}
              source={`${props.baseName}[${index}].${props.valueName}`}
              validate={ValidateRequired} />
            <div style={{ display: 'inline' }}>
              <DeleteItem fields={props.fields} index={index} />
            </div>
          </div>
        </div>
      )
    })}
    <div style={{ paddingTop: 20 }}>
      <CreateItem fields={props.fields} label={props.addItemLabel} />
    </div>
  </div>
);

KeyValueInput.defaultProps = {
  containerWidth: '100%',
  keyLabel: 'Name',
  keyName: 'name',
  valueLabel: 'Value',
  valueName: 'value'
};

export default withStyles(styles)(KeyValueInput);



// WEBPACK FOOTER //
// ./src/views/Common/Utils/KeyValueInput.tsx